

import Vue from 'vue'
import Vuex from 'vuex'

import state from './state'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'

Vue.use(Vuex)

// import moduleTodo from './todo/moduleTodo.js'
// import moduleCalendar from './calendar/moduleCalendar.js'
// import moduleChat from './chat/moduleChat.js'
// import moduleEmail from './email/moduleEmail.js'
import moduleQurban from './qurban/moduleQurban.js'
import moduleReferal from './referal/moduleReferal.js'
import moduleMedsos from './medsos/moduleMedsos.js'
import moduleVerUpd from './versionUpdate/moduleVerUpd.js'
import moduleJournal from './journal/moduleJournal.js'
import moduleZIS from './zis/moduleZIS.js'
import modulePenyaluran from './penyaluran/modulePenyaluran.js'
import moduleLembaga from './lembaga/moduleLembaga.js'
import moduleTransaksi from './transaksi/moduleTransaksi.js'
import moduleKontak from './kontak/moduleKontak.js'
import moduleAbout from './about/moduleAbout.js'
import moduleWilayah from './wilayah/moduleWilayah.js'
import modulePPOB from './ppob/modulePPOB.js'
import moduleLocation from './location/moduleLocation.js'
import moduleSOS from './sos/moduleSOS.js'
import moduleNews from './news/moduleNews.js'
import moduleBanner from './banner/moduleBanner.js'
import moduleCampaign from './campaign/moduleCampaign.js'
import moduleMenus from './menus/moduleMenus.js'
import moduleRole from './roles/moduleRole.js'
import moduleLevel from './level/moduleLevel.js'
import moduleAuth from './auth/moduleAuth.js'
import moduleUsers from './users/moduleUsers.js'
import moduleFile from './file/moduleFile.js'
import moduleECommerce from './eCommerce/moduleECommerce.js'


export default new Vuex.Store({
  getters,
  mutations,
  state,
  actions,
  modules: {
    // todo: moduleTodo,
    // calendar: moduleCalendar,
    // chat: moduleChat,
    // email: moduleEmail,
    qurban: moduleQurban,
    referal: moduleReferal,
    medsos : moduleMedsos,
    versionUpdate : moduleVerUpd,
    journal : moduleJournal, 
    zis: moduleZIS,
    penyaluran : modulePenyaluran,
    lembaga : moduleLembaga,
    transaksi : moduleTransaksi,
    kontak: moduleKontak,
    about: moduleAbout,
    ppob: modulePPOB,
    wilayah: moduleWilayah,
    location : moduleLocation,
    sos : moduleSOS,
    news : moduleNews,
    banner : moduleBanner,
    role : moduleRole,
    campaign : moduleCampaign,
    file : moduleFile,
    users : moduleUsers,
    menus : moduleMenus,
    level : moduleLevel,
    auth: moduleAuth,
    eCommerce: moduleECommerce
  },
  strict: process.env.NODE_ENV !== 'production'
})
